import videojs from 'video.js';
import './blur-video-background';
import './videojs-blur-background.css';

export default function blurBackground(options) {
  this.ready(() => {
    this.el_.classList.add('vjs-blur-background');
    // Блюр должен быть первым чтобы не перекрывать другие элементы
    // Если передать в addChild третьим аргументом 0, то на некоторых устройствах появляется ошибка
    this.el().insertAdjacentElement(
      'afterbegin',
      this.addChild('BlurVideoBackground', options).el()
    );
  });
}

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
registerPlugin('blurBackground', blurBackground);
